module.exports = __webpack_public_path__ + "static/media/it-ites.57302757.png";